export const generateDataCategories: (arg0: any[], arg1: string, arg2: string) => Record<string, any[]> = (
  data,
  emissionType,
  type,
) => data.reduce((acc: any, entry: any) => {
  if (!acc[entry[type]]) {
    acc[entry[type]] = [];
  }
  acc[entry[type]].push({
    ...entry,
    [emissionType]: entry[emissionType] ?? 0,
  });
  return acc;
}, {});

export const generateRenewableNonRenewableCategories: (arg0: any[]) => Record<string, any[]> = (
  data,
) => data.reduce((acc: any, entry: any) => {
  if (!acc.renewableConsumption) {
    acc.renewableConsumption = [];
  }
  if (!acc.noRenewableConsumption) {
    acc.noRenewableConsumption = [];
  }

  acc.renewableConsumption.push({
    ...entry,
    consumption: entry.renewableConsumption ?? 0,
  });

  acc.noRenewableConsumption.push({
    ...entry,
    consumption: entry.noRenewableConsumption ?? 0,
  });

  return acc;
}, {});

